import $ from 'jquery';

$(function () {
    $('#main-nav').on('show.bs.collapse', function () {
        $('body').addClass('menu-shown');
    }).on('hide.bs.collapse', function () {
        $('body').removeClass('menu-shown');
    });

    $(function () {
        $('.disable-on-submit').submit(function () {
            $(this).find('[type=submit]').prop('disabled', true);
        });

        $('.form-upload-file input').change(function () {
            let fileNames = $(this).parents('form').find('.file-names');
            fileNames.html('');

            if (this.files.length > 0) {
                Array.from(this.files).forEach(file => {
                    let tmp = $("<div class='small'>");
                    tmp.text(file.name);

                    fileNames.append(tmp);
                });
            }
        });
    });
});
